@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import org.lennycodes.gradematewebsite.AdminDownloadsPage as _org_lennycodes_gradematewebsite_AdminDownloadsPage
import org.lennycodes.gradematewebsite.Login as _org_lennycodes_gradematewebsite_Login
import org.lennycodes.gradematewebsite.pages.GradeMatePage as _org_lennycodes_gradematewebsite_pages_GradeMatePage
import org.lennycodes.gradematewebsite.pages.HomePage as _org_lennycodes_gradematewebsite_pages_HomePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "GradeMate Official Site"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _org_lennycodes_gradematewebsite_pages_HomePage()
        }
        ctx.router.register(
            "/admin",
        ) { pageCtx -> 
            _org_lennycodes_gradematewebsite_AdminDownloadsPage()
        }
        ctx.router.register(
            "/grademate",
        ) { pageCtx -> 
            _org_lennycodes_gradematewebsite_pages_GradeMatePage()
        }
        ctx.router.register(
            "/login",
        ) { pageCtx -> 
            _org_lennycodes_gradematewebsite_Login()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("download-card", org.lennycodes.gradematewebsite.components.DownloadCardStyle)
        ctx.theme.registerStyle("contact-field", org.lennycodes.gradematewebsite.components.ContactFieldStyle)
        ctx.theme.registerStyle("section", org.lennycodes.gradematewebsite.components.style.SectionStyle)
        ctx.theme.registerStyle("section-inner", org.lennycodes.gradematewebsite.components.style.SectionInnerStyle)
        ctx.theme.registerStyle("responsive-row", org.lennycodes.gradematewebsite.components.style.ResponsiveRowStyle)
        ctx.theme.registerStyle("quick-start-grid", org.lennycodes.gradematewebsite.components.style.QuickStartGridStyle)
        ctx.theme.registerStyle("downloads-grid", org.lennycodes.gradematewebsite.components.style.DownloadsGridStyle)
        ctx.theme.registerStyle("button-group", org.lennycodes.gradematewebsite.components.style.ButtonGroupStyle)
        ctx.theme.registerStyle("eyebrow", org.lennycodes.gradematewebsite.components.style.EyebrowStyle)
        ctx.theme.registerStyle("section-heading", org.lennycodes.gradematewebsite.components.style.SectionHeadingStyle)
        ctx.theme.registerStyle("section-subtitle", org.lennycodes.gradematewebsite.components.style.SectionSubtitleStyle)
        ctx.theme.registerStyle("primary-button", org.lennycodes.gradematewebsite.components.style.PrimaryButtonStyle)
        ctx.theme.registerStyle("secondary-button", org.lennycodes.gradematewebsite.components.style.SecondaryButtonStyle)
        ctx.theme.registerStyle("card", org.lennycodes.gradematewebsite.components.style.CardStyle)
        ctx.theme.registerStyle("nav-link", org.lennycodes.gradematewebsite.components.style.NavLinkStyle)
        ctx.theme.registerStyle("desktop-nav-links", org.lennycodes.gradematewebsite.components.style.DesktopNavLinksStyle)
        ctx.theme.registerStyle("mobile-menu-button", org.lennycodes.gradematewebsite.components.style.MobileMenuButtonStyle)
        ctx.theme.registerStyle("footer", org.lennycodes.gradematewebsite.components.style.FooterStyle)
        ctx.theme.registerStyle("footer-link", org.lennycodes.gradematewebsite.components.style.FooterLinkStyle)
        ctx.theme.registerStyle("skeleton", org.lennycodes.gradematewebsite.components.style.SkeletonStyle)
        ctx.theme.registerStyle("highlight-tile-grid", org.lennycodes.gradematewebsite.components.style.HighlightTileGridStyle)
        ctx.theme.registerStyle("login-page", org.lennycodes.portfolio.styles.LoginPageStyle)
        ctx.theme.registerStyle("login-card", org.lennycodes.portfolio.styles.LoginCardStyle)
        ctx.theme.registerStyle("login-logo", org.lennycodes.portfolio.styles.LoginLogoStyle)
        ctx.theme.registerStyle("login-title", org.lennycodes.portfolio.styles.LoginTitleStyle)
        ctx.theme.registerStyle("login-subtitle", org.lennycodes.portfolio.styles.LoginSubtitleStyle)
        ctx.theme.registerStyle("login-field-group", org.lennycodes.portfolio.styles.LoginFieldGroupStyle)
        ctx.theme.registerStyle("login-label", org.lennycodes.portfolio.styles.LoginLabelStyle)
        ctx.theme.registerStyle("login-input", org.lennycodes.portfolio.styles.LoginInputStyle)
        ctx.theme.registerStyle("login-button", org.lennycodes.portfolio.styles.LoginButtonStyle)
        ctx.theme.registerStyle("login-error", org.lennycodes.portfolio.styles.LoginErrorStyle)
        ctx.theme.registerKeyframes("wobble", org.lennycodes.gradematewebsite.components.style.WobbleKeyframes)
        org.lennycodes.gradematewebsite.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        org.lennycodes.gradematewebsite.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
